/** @format */

import React from "react";
import { StarIcon } from "@heroicons/react/solid";
import { Link } from "react-router-dom";

import BookmarkButton from "../BookmarkButton";
import { removeSpaces } from "../helpers/arrayHelpers";

export default function ContentCardNoHover(props) {
  const { name, cover_image, rating, id } = props.data;
	return (
		<div className="relative group pb-2  rounded-lg shadow">
			<div className="shadow absolute max-w-xs px-2 py-0.5 text-xs bg-gray-50 top-3 z-20 cursor-pointer rounded-xl text-center right-2 ">
				<BookmarkButton id={id} cover_image={cover_image} name={name} />
			</div>

			<Link to={`/anime/${id}/${removeSpaces(name)}`}>
				<div className=" min-w-[150px] max-w-[150px] md:min-w-[190px] md:max-w-[190px] relative shadow-md hover:shadow-lg duration-200   h-[230px] md:h-[250px] overflow-hidden  rounded-xl ">
					<img
						loading="lazy"
						className="w-full  group-hover:scale-110 hover:brightness-75 filter duration-300 transform h-full object-cover rounded-lg "
						src={cover_image}
						alt={name}
					/>
					<div className="absolute z-30 top-3  left-3 flex flex-row px-3 h-5 bg-gray-50 rounded-2xl">
						<StarIcon className=" text-yellow-500 h-5 w-5"></StarIcon>
						<span className=" text-xs p-0.5 text-gray-500 ">{rating}</span>
					</div>
				</div>
				<p className="mt-2 font-ubuntu text-sm truncate min-w-[150px] max-w-[150px] md:min-w-[190px] md:max-w-[190px] text-black dark:text-gray-300 font-semibold text-center  ">
					{name}{" "}
				</p>
			</Link>
		</div>
	);
}
